import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import { Grid } from '@mui/material'
import Checkbox from '../../../../components/forms/Checkbox'
import Input from '../../../../components/forms/Input'
import NumberField from '../../../../components/forms/NumberField'
import Select from '../../../../components/forms/Select'
import ContributorDto from '../../../../referencial/components/contributor/dto/ContributorDto'
import { antennaTypeShape } from '../dto/AntennaTypeShape'

const AntennaTypePanel = ({
    materielType = {},
    onChange = () => {},
    disabled = false,
    showContributorField = true,
    contributors = [],
}) => (
    <Grid container spacing={1}>
        {showContributorField && (
            <>
                <Grid size={6}>
                    <Select
                        options={contributors}
                        label={i18n.provider}
                        value={materielType.provider}
                        onChange={v => onChange({ provider: v })}
                        keyValue='id'
                        keyLabel='mnemonique'
                        disabled={disabled}
                    />
                </Grid>
                <Grid size={6}>
                    <Select
                        options={contributors}
                        label={i18n.manufacturer}
                        value={materielType.manufacturerId}
                        onChange={v => onChange({ manufacturerId: v })}
                        keyValue='id'
                        keyLabel='mnemonique'
                        disabled={disabled}
                    />
                </Grid>
            </>
        )}
        <Grid size={4}>
            <NumberField
                title={i18n.voltage}
                value={materielType.voltage}
                onChange={v => onChange({ voltage: v })}
                floatValue
                disabled={disabled}
            />
        </Grid>
        <Grid size={4}>
            <NumberField
                title={i18n.duration}
                value={materielType.duration}
                onChange={v => onChange({ duration: v })}
                floatValue
                disabled={disabled}
            />
        </Grid>
        <Grid size={4}>
            <NumberField
                title={`${i18n.cableLength} (m)`}
                value={materielType.cableLength}
                onChange={v => onChange({ cableLength: v })}
                floatValue
                disabled={disabled}
            />
        </Grid>
        <Grid size={8}>
            <Input
                title={i18n.locationSituation}
                value={materielType.locationSituation}
                onChange={v => onChange({ locationSituation: v })}
                disabled={disabled}
            />
        </Grid>
        <Grid size={4}>
            <Checkbox
                label={i18n.nonReplaceable}
                checked={materielType.nonReplaceable}
                onChange={v => onChange({ nonReplaceable: v })}
                disabled={disabled}
            />
        </Grid>
    </Grid>
)

AntennaTypePanel.propTypes = {
    materielType: antennaTypeShape,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    showContributorField: PropTypes.bool,
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),
}

const mapStateToProps = store => ({
    contributors: store.ContributorReducer.contributors,
})

export default connect(mapStateToProps)(AntennaTypePanel)